import format from 'date-fns/format'
import { useState } from 'react';
import { Box, Typography, Button } from "@mui/material";
import { reduce } from 'lodash';
import {useTranslation} from "react-i18next";

const addHalfHour = (time) => {
    const times = time.split(':');
    let hours = parseInt(times[0]);
    let minutes = parseInt(times[1]);

    // Handle the special case for 24:00
    if (hours === 24 && minutes === 0) {
        hours = 0; // Reset to 00:00
    }

    const date = new Date(2022, 1, 1, hours, minutes, 0, 0);
    return format(new Date(date.getTime() + (30 * 60 * 1000)), 'HH:mm');
};
   
const Schedule = ({ cancel, done, data }) => {
    const [isDragging, setIsDragging] = useState(false); // Track if the user is dragging
    const [dragStart, setDragStart] = useState(null); // Track the starting point of the drag
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();
    const days = [`${t("monday")}`, `${t("tuesday")}`, `${t("wednesday")}`, `${t("thursday")}`, `${t("friday")}`, `${t("saturday")}`, `${t("sunday")}`];
    const slots = Array.apply(0, new Array(48)).map((v, index) => `${format(new Date(new Date(currentYear, 1, 1, 0, 0, 0, 0).getTime() + (index * 30 * 60 * 1000)), 'HH:mm')}`);

    const [selected, setSelected] = useState(reduce(data, (result, item) => {
        let { startTimeSlot, endTimeSlot } = item;

        const items = [];

        // Handle the case where the full day is selected
        if (startTimeSlot === '00:00' && endTimeSlot === '24:00') {
            slots.forEach((slot) => {
                items.push({
                    ...item,
                    startTimeSlot: slot,
                    endTimeSlot: addHalfHour(slot),
                });
            });
            return result.concat(items);
        }

        items.push({
            ...item,
            endTimeSlot: startTimeSlot,
        });


        // Handle the case where endTimeSlot is 24:00
        if (endTimeSlot === '24:00') {
            endTimeSlot = '00:00'; // Treat 24:00 as 00:00 of the next day
        }

        while (endTimeSlot !== startTimeSlot) {
            startTimeSlot = addHalfHour(startTimeSlot);

            // Skip adding the next day's 00:00 unless explicitly selected
            if (startTimeSlot === '00:00' && endTimeSlot === '00:00') {
                break;
            }

            items.push({
                ...item,
                endTimeSlot: startTimeSlot,
                startTimeSlot: startTimeSlot,
            });
        }
        console.log(items);
        return result.concat(items);
    }, []));


    const setDateSelected = (index, day, timeString) => {
        const time = timeString.split(' ')[0];
        // Handle the case for 24:00
        if (time === '24:00') {
            time = '00:00';
        }
        const find = selected.find(t => t.dayOfWeek === day && t.startTimeSlot === time);

        if (find) {
            setSelected(selected.filter(t => !(t.dayOfWeek === day && t.startTimeSlot === time)));
        } else {
            setSelected(selected.concat({
                dayOfWeek: day,
                startTimeSlot: time,
                start: index,
                endTimeSlot: time,
            }));
        }
    };

    const isSelected = (index, day, value) => {
        return selected.filter(t => t.dayOfWeek === day && t.startTimeSlot === value).length !== 0;
    };

    const handleMouseDown = (index, day, value) => {
        if (isDragging) {
            // If already dragging, stop dragging
            setIsDragging(false);
            setDragStart(null);
        } else {
            // Start dragging
            setIsDragging(true);
            setDragStart({ index, day, value }); // Track the starting point of the drag
            setDateSelected(index, day, value); // Select the first slot on click
        }

    };

    const handleMouseEnter = (index, day, value) => {
        if (isDragging) {
            setDateSelected(index, day, value); // Select slots while dragging
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false); // Stop dragging
        setDragStart(null); // Clear the starting point
    };

    console.log(isDragging);

    return (
        <>
            <div className="db" onMouseUp={handleMouseUp} onMouseLeave={handleMouseUp}>
                <div className="dib day-of-week"></div>
                {days.map(d => (
                    <div className="dib day-of-week" key={d}>{d}</div>
                ))}
            </div>
            {slots.map((value, index) => (
                <div className="flex pt-2 pb-2" key={`row_${index}`}>
                    <div className="dib day-of-week-hour">{value}</div>
                    {days.map(d => (
                        <div className={`dib day-of-week-row ${isSelected(index, d, value) ? 'day-of-week-row-selected' : ''}`} key={d}
                            onMouseDown={() => handleMouseDown(index, d, value)} // Start dragging or select on click
                            onMouseEnter={() => handleMouseEnter(index, d, value)} // Drag over slots
                        >&nbsp;</div>
                    ))}
                </div>
            ))}

            <Box textAlign='left'
                sx={{
                    minWidth: "500px",
                    borderRadius: '5px',
                    borderWidth: '0',
                    borderStyle: 'solid',
                    backgroundColor: '#E8F3F4',
                    mt: 3
                }}
            >
                <Button
                    variant="contained"
                    onClick={() => done(selected)}
                    sx={{ mt: 1, mb: 1, ml: 2 }}
                    style={{
                        borderRadius: 7,
                        backgroundColor: "#1f9997",
                        fontSize: "14px",
                        width: "190px",
                        height: 40
                    }}
                >
                    <Typography style={{ fontFamily: 'Poppins', fontSize: 14, textTransform: 'none', color: "white" }}>{t("schedule")}</Typography>
                </Button>

                <Button>
                    <Typography style={{ fontFamily: 'Poppins', fontSize: 14, fontWeight: 600, textTransform: 'none', color: "#BDBDBD" }}
                        onClick={() => cancel()} >{t("cancel")}</Typography>
                </Button>
            </Box>
        </>
    );
};

export default Schedule;
